import React from 'react';

const Pagination = ({ currentPage, totalItems, itemsPerPage, onPageChange }) => {
    const totalPages = Math.ceil(totalItems / itemsPerPage);

    // Fonction pour générer un tableau des numéros de page à afficher
    const generatePageNumbers = () => {
        const pageNumbers = [];
        const maxPagesToShow = 5; // Nombre maximum de pages à afficher (hors ellipsis)
        
        if (totalPages <= maxPagesToShow) {
            // Si le nombre total de pages est petit, afficher toutes les pages
            for (let i = 1; i <= totalPages; i++) {
                pageNumbers.push(i);
            }
        } else {
            // Toujours inclure la première page
            pageNumbers.push(1);
            
            // Calculer la plage de pages autour de la page courante
            const leftSide = Math.floor(maxPagesToShow / 2);
            const rightSide = maxPagesToShow - leftSide - 1;
            
            // Déterminer si nous devons ajouter un ellipsis au début
            if (currentPage > leftSide + 1) {
                pageNumbers.push('...');
            }
            
            // Calculer les limites de la plage de pages autour de la page courante
            let startPage = Math.max(2, currentPage - leftSide);
            let endPage = Math.min(totalPages - 1, currentPage + rightSide);
            
            // Ajuster si nous sommes près du début
            if (currentPage < leftSide + 1) {
                endPage = Math.min(maxPagesToShow - 1, totalPages - 1);
            }
            
            // Ajuster si nous sommes près de la fin
            if (currentPage > totalPages - rightSide - 1) {
                startPage = Math.max(2, totalPages - maxPagesToShow + 1);
            }
            
            // Ajouter les pages de la plage
            for (let i = startPage; i <= endPage; i++) {
                pageNumbers.push(i);
            }
            
            // Déterminer si nous devons ajouter un ellipsis à la fin
            if (endPage < totalPages - 1) {
                pageNumbers.push('...');
            }
            
            // Toujours inclure la dernière page si différente de la première
            if (totalPages > 1) {
                pageNumbers.push(totalPages);
            }
        }
        
        return pageNumbers;
    };

    const pageNumbers = generatePageNumbers();

    return (
        <div className="pagination flex justify-center items-center mt-4">
            <button
                onClick={() => onPageChange(currentPage - 1)}
                disabled={currentPage === 1}
                className="mx-2 px-4 py-2 border rounded-md bg-gray-200 hover:bg-gray-300 disabled:opacity-50"
            >
                Précédent
            </button>
            {pageNumbers.map((number, index) => (
                number === '...' ? (
                    <span key={`ellipsis-${index}`} className="mx-1 px-3 py-2">
                        {number}
                    </span>
                ) : (
                    <button
                        key={number}
                        onClick={() => onPageChange(number)}
                        className={`mx-1 px-3 py-2 border rounded-md ${
                            currentPage === number 
                                ? 'bg-primary text-white' 
                                : 'bg-gray-200 hover:bg-gray-300'
                        }`}
                    >
                        {number}
                    </button>
                )
            ))}
            <button
                onClick={() => onPageChange(currentPage + 1)}
                disabled={currentPage === totalPages}
                className="mx-2 px-4 py-2 border rounded-md bg-gray-200 hover:bg-gray-300 disabled:opacity-50"
            >
                Suivant
            </button>
        </div>
    );
};

export default Pagination;
